import { useQuery } from '@hooks/reactQuery';

import { getPortalMilestoneById } from '@api/portalMilestones';

import { extractQueryParams } from '@utils/common';

import { IPortalMilestoneDTO } from '@interfaces/portal/dto/milestonesManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_MILESTONE } from '@constants/queryKeys';

interface IUseQueryPortalMilestoneReturned {
	isFetchingPortalMilestone: boolean;
	portalMilestone?: IPortalMilestoneDTO;
}

export const useQueryPortalMilestone = (id: string | null): IUseQueryPortalMilestoneReturned => {
	const {
		data,
		isFetching,
	} = useQuery<IPortalMilestoneDTO>({
			queryKey: [GET_PORTAL_MILESTONE, id],
			queryFn: extractQueryParams(getPortalMilestoneById),
			enabled: [!!id],
			...refetchOptions,
		},
	);

	return {
		isFetchingPortalMilestone: isFetching,
		portalMilestone: data,
	};
};
